import React from 'react';

//the context to save the user infos
export const UserInfoContext = React.createContext({
    idUser: "",
    idAccount: "",
    idRight: "[]"
});

